import { Box , styled } from '@mui/material';

const StyledBox = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 800,
  maxHeight: '90vh',
  overflow: 'auto',
  backgroundColor: 'transparent',
  borderRadius: 2,
  padding: 3,
}));

export { StyledBox };